import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { FunnyReactionContainer as h, HelpfulReactionContainer as F, LikeReactionContainer as T, Container as N } from "./style.js";
import { Icon as l } from "../../../../components/Icon/index.js";
import { ReactionType as t, ReactAction as s } from "../../types.js";
import { useTranslation as U } from "../../../../hooks/useTranslation/index.js";
import { FaceLaughSquint as b, SquareCheck as k, ThumbsUp as R } from "@pelando/fontawesome/icons";
const Y = ({
  reacted: o,
  id: i,
  dispatch: a,
  ...m
}) => {
  const { t: n } = U("common"), p = {
    [t.FUNNY]: h,
    [t.HELPFUL]: F,
    [t.LIKE]: T
  }, u = {
    [t.FUNNY]: n("comment-actions-funny-label"),
    [t.HELPFUL]: n("comment-actions-helpful-label"),
    [t.LIKE]: n("comment-actions-like-label")
  }, y = {
    [t.FUNNY]: b,
    [t.HELPFUL]: k,
    [t.LIKE]: R
  }, L = {
    [t.FUNNY]: n("comment-actions-funny-text"),
    [t.HELPFUL]: n("comment-actions-helpful-text"),
    [t.LIKE]: n("comment-actions-like-text")
  }, f = !!o, C = () => {
    a({
      type: s.REMOVE_REACTION,
      payload: {
        id: i
      }
    });
  }, E = (c) => {
    a({
      type: s.REACT,
      payload: {
        id: i,
        type: c
      }
    });
  };
  if (f) {
    const c = p[o];
    return /* @__PURE__ */ r(
      c,
      {
        title: n(
          "comment-actions-remove-react-button-title",
          u[o]
        ),
        onClick: C,
        ...m,
        children: [
          /* @__PURE__ */ e(l, { icon: y[o] }),
          /* @__PURE__ */ e("span", { children: L[o] })
        ]
      }
    );
  }
  return /* @__PURE__ */ r(
    N,
    {
      onReactClick: E,
      title: n("comment-actions-react-button-title"),
      ...m,
      children: [
        /* @__PURE__ */ e(l, { icon: R }),
        /* @__PURE__ */ e("span", { children: n("comment-actions-react-button-title") })
      ]
    }
  );
};
export {
  Y as ReactButton
};
